export default __webpack_public_path__ + "static/media/angbao-bonus-thaipusam.8ae47abf.webp";